//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { testing, testingMessage, passcode } from '~/testing.config'
import SelectionsMixin from '~/mixins/SelectionsMixin'
import Header from '~sdp-components/Header/Header'
import Navigation from '~/components/Navigation'
import Footer from '~sdp-components/Footer/Footer'
import Columns from '~sdp-components/PageElements/Columns'
import Column from '~sdp-components/PageElements/Column'
import QlikSelectedFilterPills from '~sdp-components/Qlik/QlikSelectedFilterPills'
import QlikCollapsableFilterContainer from '~sdp-components/Qlik/QlikCollapsableFilterContainer'
import QlikFilter from '~sdp-components/Qlik/QlikFilter'
import Square from '~sdp-components/PageElements/Square'
import Heading from '~sdp-components/PageElements/Heading'
import AuthenticatePasscode from '~sdp-components/Authentication/AuthenticatePasscode'

export default {
  components: {
    AuthenticatePasscode,
    Header,
    Navigation,
    Footer,
    Columns,
    Column,
    QlikSelectedFilterPills,
    QlikFilter,
    QlikCollapsableFilterContainer,
    Square,
    Heading,
  },
  mixins: [SelectionsMixin],
  data() {
    return {
      incorrectPasscodeMessage: undefined,
      tourSteps: [
        {
          target: '#main-title',
          content:
            'Welcome to the School Progress Report on Eduation and Equity (SPREE) website. Here you can find data about school performance and climate for both district and public charters schools in Philadelphia.',
          params: { enableScrolling: true },
          offset: -400,
        },
        // {
        //   target: '#main-nav',
        //   content:
        //     'This website is divided into four sections. The first two sections display data about all schools. "School Report" and "Calculator" display data about a single school.',
        //   params: { enableScrolling: false },
        // },
        {
          target: '#main-nav',
          content:
            'This website is divided into three sections. The first two sections display data about all schools. The "School Report" section displays data about a single school.',
          params: { enableScrolling: true },
          offset: -500,
        },
        {
          target: '#main-content-side',
          content:
            'Here you can view charts, maps, and tables related to SPREE metrics.',
          params: {
            enableScrolling: true,
            placement: 'left',
          },
        },
        {
          target: '#a265a203-1e8a-440d-80ca-e6160c649b84_content',
          content:
            "Click 'Switch to Table View' or hover over the chart to see individual school information.",
          params: { enableScrolling: true, placement: 'left' },
          offset: -400,
        },
        {
          target: '#main-filter-panel',
          content:
            'On this panel you can find a number of filters to narrow down the displayed schools and metrics.',
          params: { enableScrolling: true },
          offset: -400,
        },
        /*         {
          target: '#main-domains',
          content:
            'SPREE metrics are divided into categories, known as "Domains". You can select a specific domain to change the displayed values. After selecting a domain, you can further select a single metric.',
          params: { enableScrolling: false },
        }, */
        {
          target: '#main-filters',
          content:
            'Use the filters to narrow down school or report characteristics.',
          params: { enableScrolling: false },
        },
        {
          target: '#main-school-filter',
          content:
            'Use the school filter to choose one or more school reports. Some schools may have more than one report (for example Middle-High schools).',
          params: { enableScrolling: false },
        },
        {
          target: '#main-tour-button',
          content: 'Press here to take this tour again.',
          params: { enableScrolling: true },
          offset: -400,
        },
      ],

      tourCallbacks: {
        onSkip: () => this.$store.dispatch('tour/initialize_main'),
        onFinish: () => this.$store.dispatch('tour/initialize_main'),
      },
    }
  },
  computed: {
    authenticated() {
      return this.$store.state.authenticated
    },
    bannerMessage() {
      return testing && testingMessage ? testingMessage : undefined
    },
    print() {
      return this.$route.query?.print === 'true' || false
    },
  },
  mounted() {
    if (!this.$store.state.tour.main_initialized && this.authenticated)
      this.launchTour()
  },
  /**
   * Remove field values that we don't want to carry to other pages
   */
  async destroyed() {
    const fieldsToClear = ['metric_label', 'domain']
    const engine = await this.$qlik.engine
    let field
    fieldsToClear.forEach(async (fieldName) => {
      field = await engine.getField(fieldName)
      await field.clear()
    })
  },
  methods: {
    async checkPasscode(_passcode) {
      const passcodeValid = _passcode === passcode
      await this.$store.dispatch('set_authenticated', passcodeValid)
      this.incorrectPasscodeMessage = passcodeValid
        ? undefined
        : 'Incorrect password, please try again.'
    },
    launchTour() {
      this.$tours.mainTour.start()
      this.$store.dispatch('tour/initialize_main')
    },
  },
}
